import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-12 items-center pt-8 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Tipo de contrato *", -1)
const _hoisted_3 = { class: "col-span-2 flex flex-row items-center gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: ""
}, "Seleccione una opción", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "RENT" }, "Arriendo", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "RENT_PURCHASE_SALE" }, " Arriendo con opción de compra ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "PURCHASE_SALE" }, "Compra", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "SALE" }, "Venta", -1)
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Fecha * ", -1)
const _hoisted_11 = { class: "col-span-2 flex flex-row gap-4 items-center" }
const _hoisted_12 = { class: "relative flex flex-row items-center gap-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-4 h-full items-start pt-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm whitespace-nowrap" }, "Comentario")
], -1)
const _hoisted_14 = { class: "col-span-2" }
const _hoisted_15 = { class: "col-span-3 flex flex-row items-center gap-2 justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Notificar indefinidamente", -1)
const _hoisted_17 = { class: "col-span-3 flex flex-col w-full" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-400" }, "Formatos permitidos: pdf", -1)
const _hoisted_19 = { class: "flex flex-row justify-center items-center gap-4 w-full" }
const _hoisted_20 = ["disabled"]

import { ref, watch, onMounted, computed } from "vue";

import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";

import { useContractStore } from "@/stores/contract";

import NewModal from "@/components/atoms/NewModal.vue";
import Switch from "@/components/atoms/Switch.vue";
import { mdiTrumpet } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewContractModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





const route = useRoute();
const investmentId = ref(+route.params.id);

const contractStore = useContractStore();
const { createResponse, newContract } = storeToRefs(contractStore);

const createIsPending = ref<boolean>(false);

const handleCreateContract = async () => {
  createIsPending.value = true;
  await contractStore.createContract();
};

const handleFile = async (event: Event) => {
  if (event.target && event.target.files[0]) {
    newContract.value.thumbnail = event.target.files[0];
  }
};

// Validation rules
const disableSubmit = computed(
  () =>
    newContract.value.investment_id == "" ||
    newContract.value.type == "" ||
    newContract.value.start_date == undefined ||
    newContract.value.thumbnail == "" ||
    newContract.value.thumbnail == null ||
    createIsPending.value == true
);

watch(createResponse, () => {
  if (createResponse.value.success) {
    emit("update:visible");
    Swal.fire("Listo!", "Contrato creado exitosamente!", "success");
    createIsPending.value = false;
  } else {
    emit("update:visible");
    Swal.fire("Error!", "Oops, hubo un error.", "error");
    createIsPending.value = false;
  }
});

watch(props, () => {
  if (props.visible == false) {
    contractStore.clearNewContract();
    newContract.value.investment_id = investmentId.value;
  }
});

onMounted(() => {
  newContract.value.investment_id = investmentId.value;
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createBlock(NewModal, {
    title: "Crear contrato de movimiento",
    visible: __props.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = () => _ctx.$emit('update:visible'))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (handleCreateContract())),
          disabled: disableSubmit.value,
          class: "flex flex-row items-center rounded-full px-4 py-2 bg-green-700 text-sm shadow text-white disabled:bg-gray-500 transition-all"
        }, " Enviar ", 8, _hoisted_20)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            class: "border border-gray-300 text-sm p-2 w-96 rounded-md",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(newContract).type) = $event)),
            onChange: _cache[1] || (_cache[1] = 
            () => {
              _unref(newContract).end_date = undefined;
            }
          )
          }, _hoisted_9, 544), [
            [_vModelSelect, _unref(newContract).type]
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Datepicker, {
              modelValue: _unref(newContract).start_date,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(newContract).start_date) = $event)),
              "teleport-center": "",
              "input-class-name": "newcalssinput",
              "enable-time-picker": false,
              format: "dd/MM/yyyy",
              cancelText: 'Cancelar',
              selectText: 'Seleccionar'
            }, null, 8, ["modelValue"]),
            _createTextVNode(" - "),
            _createVNode(_component_Datepicker, {
              modelValue: _unref(newContract).end_date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(newContract).end_date) = $event)),
              "teleport-center": "",
              "input-class-name": "newcalssinput",
              "enable-time-picker": false,
              format: "dd/MM/yyyy",
              cancelText: 'Cancelar',
              selectText: 'Seleccionar',
              disabled: 
              _unref(newContract).start_date == null ||
              _unref(newContract).start_date == undefined ||
              _unref(newContract).type == 'PURCHASE_SALE' ||
              'SALE'
            
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("textarea", {
            class: "border w-full border-gray-300 rounded-md p-2 text-sm",
            maxlength: "1000",
            placeholder: "Agregue un comentario...",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(newContract).comment) = $event))
          }, null, 512), [
            [_vModelText, _unref(newContract).comment]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(Switch, {
            actived: _unref(newContract).notify_indefinitely,
            "onUpdate:actived": _cache[5] || (_cache[5] = 
            () => {
              _unref(newContract).notify_indefinitely =
                !_unref(newContract).notify_indefinitely;
            }
          )
          }, null, 8, ["actived"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("input", {
            onChange: _cache[6] || (_cache[6] = (event) => handleFile(event)),
            type: "file",
            class: "file:bg-green-700 file:rounded-full file:text-white file:shadow-lg file:px-4 file:py-1.5 file:text-sm file:border-0 gap-2 file:mb-4",
            accept: ".pdf, .docx"
          }, null, 32),
          _hoisted_18
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})